import { OPMCalculator } from 'api';
import { getStringValue } from 'utilities';

// A tab added in this session carries a client-generated `panelId` (uuid) that the backend never
// stores; once saved, the API returns `panel_id` derived from the row's pk. Both spellings are in
// play at once, so every lookup goes through here instead of repeating the fallback.
const getOPMCalculatorPanelId = (opmCalculator?: OPMCalculator | null): string => {
  const withPanelId = opmCalculator as (OPMCalculator & { panelId?: string }) | null | undefined;

  return getStringValue(withPanelId?.panelId ?? opmCalculator?.panel_id);
};

export default getOPMCalculatorPanelId;
